import CheckedIcon from '@assets/images/icons/check.svg?react'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type * as React from 'react'
import { useSelector } from 'react-redux'

import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { Tooltip } from '../Tooltip'
import css from './SelectedButton.module.scss'

type Props = {
  unit: string
  isEstimate: boolean
  color: string
  onToggleItem: () => void
}

export const SelectedButton: React.FC<Props> = ({
  unit,
  isEstimate,
  color,
  onToggleItem,
}) => {
  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const artboardDisabled = useArtBoardDisabled()

  const backgroundColor = isEstimate ? color : 'transparent'

  if (isReadOnly || artboardDisabled) {
    return (
      <div
        className={cx(css.toggle, {
          [css.checked]: isEstimate,
        })}
        style={{ backgroundColor }}
      >
        <CheckedIcon />
      </div>
    )
  }

  return (
    <Tooltip
      content={
        <span>
          {isEstimate ? 'Unlink' : 'Set'}{' '}
          <span className={css.unit}>{unit}</span> on artboard
        </span>
      }
      offset={{ y: 6 }}
      renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
        <button
          ref={onSetRef}
          className={cx(css.toggle, {
            [css.checked]: isEstimate,
          })}
          style={{ backgroundColor }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={onToggleItem}
        >
          <CheckedIcon />
        </button>
      )}
    />
  )
}
